import { render } from "./FootPage.vue?vue&type=template&id=089f59ca"
import script from "./FootPage.vue?vue&type=script&lang=js"
export * from "./FootPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__